import { useEffect, useState } from 'react';

const navItems = [
  { id: 'hero', label: '首页' },
  { id: 'hot', label: '今日热梗' },
  { id: 'library', label: '表情大全' },
  { id: 'gif', label: '动图专区' },
  { id: 'guide', label: '使用攻略' },
  { id: 'faq', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id: string) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
        <button onClick={() => go('hero')} className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
            <i className="ri-water-flash-line" />
          </span>
          <span className="font-heading text-xl leading-none text-foreground-950">
            吃瓜<span className="text-primary-600">表情</span>站
          </span>
        </button>

        <div className="hidden items-center gap-7 md:flex">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => go(item.id)}
              className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => go('library')}
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            挑选表情包
          </button>
        </div>

        <button
          className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-lg text-foreground-800 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
        >
          <i className={open ? 'ri-close-line' : 'ri-menu-line'} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-3">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => go(item.id)}
                className="rounded-md px-3 py-2 text-left text-sm text-foreground-800 hover:bg-background-100"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => go('library')}
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50"
            >
              挑选表情包
            </button>
          </div>
        </div>
      )}
    </header>
  );
}